import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, renderSlot as _renderSlot } from "vue";
export default {
  __name: 'DynamicForm',
  props: {
    formConfig: {
      type: Object,
      required: true,
      default: () => ({
        labelWidth: '120px',
        inline: false,
        showLabel: true,
        fields: [],
        hasAction: true,
        labelPosition: 'right',
        disabled: false
      })
    },
    submitText: {
      type: String,
      default: '搜索'
    },
    hasRest: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['update:modelValue', 'handleSuccess', 'handleChange'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const dynamicFormRef = ref(null);
    const formData = ref({
      ...props.modelValue
    });
    const formRules = computed(() => {
      const rules = {};
      props.formConfig.fields.forEach(field => {
        if (field) {
          rules[field.prop] = field.rules;
        }
      });
      return rules;
    });
    watch(() => props.modelValue, newVal => {
      formData.value = JSON.parse(JSON.stringify(newVal));
      nextTick(() => {
        dynamicFormRef.value?.clearValidate();
      });
    }, {
      deep: true,
      immediate: true
    });
    const handleSubmit = () => {
      dynamicFormRef.value.validate(valid => {
        if (valid) {
          emit('update:modelValue', formData.value);
          emit('handleSuccess');
        }
      });
    };
    const updateValue = () => {
      emit('update:modelValue', formData.value);
    };
    const handleReset = () => {
      dynamicFormRef.value.resetFields();
    };
    const handleChange = (val, prop) => {
      emit('handleChange', val, prop);
    };

    // 暴露方法给父组件
    __expose({
      updateValue
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_input_number = _resolveComponent("el-input-number");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_cascader = _resolveComponent("el-cascader");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_slider = _resolveComponent("el-slider");
      const _component_el_color_picker = _resolveComponent("el-color-picker");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_vue_perfect_scrollbar = _resolveComponent("vue-perfect-scrollbar");
      return _openBlock(), _createBlock(_component_vue_perfect_scrollbar, {
        style: {
          "max-height": "55vh"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          disabled: __props.formConfig.disabled,
          ref_key: "dynamicFormRef",
          ref: dynamicFormRef,
          model: _unref(formData),
          "label-width": __props.formConfig.labelWidth || '120px',
          rules: _unref(formRules),
          inline: __props.formConfig.inline,
          "label-position": __props.formConfig.labelPosition || 'right'
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.formConfig.fields, (item, index) => {
            return _openBlock(), _createBlock(_component_el_form_item, {
              key: index,
              label: __props.formConfig.showLabel ? item.label : '',
              prop: item.prop
            }, {
              default: _withCtx(() => [item.type === 'input' ? (_openBlock(), _createBlock(_component_el_input, {
                key: 0,
                type: item.dataType || '',
                onChange: $event => handleChange($event, item.prop),
                modelValue: _unref(formData)[item.prop],
                "onUpdate:modelValue": $event => _unref(formData)[item.prop] = $event,
                "show-password": item.showPassword,
                placeholder: item.placeholder || `请输入${item.label}`,
                clearable: item.clearable,
                disabled: item.disabled
              }, null, 8, ["type", "onChange", "modelValue", "onUpdate:modelValue", "show-password", "placeholder", "clearable", "disabled"])) : item.type === 'number' ? (_openBlock(), _createBlock(_component_el_input_number, {
                key: 1,
                modelValue: _unref(formData)[item.prop],
                "onUpdate:modelValue": $event => _unref(formData)[item.prop] = $event,
                min: item.min,
                max: item.max,
                step: item.step || 1,
                placeholder: item.placeholder || `请输入${item.label}`,
                disabled: item.disabled
              }, null, 8, ["modelValue", "onUpdate:modelValue", "min", "max", "step", "placeholder", "disabled"])) : item.type === 'select' ? (_openBlock(), _createBlock(_component_el_select, {
                key: 2,
                remote: item.remote || false,
                "remote-method": item.remoteMethod,
                onChange: $event => handleChange($event, item.prop),
                disabled: item.disabled,
                style: _normalizeStyle({
                  width: item.width || '100%'
                }),
                modelValue: _unref(formData)[item.prop],
                "onUpdate:modelValue": $event => _unref(formData)[item.prop] = $event,
                placeholder: item.placeholder || `请选择${item.label}`,
                multiple: item.multiple,
                "collapse-tags": item.collapseTags,
                clearable: item.clearable,
                filterable: item.filterable
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, opt => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: opt.value,
                    label: typeof opt === 'object' ? opt[item.labelKey] || opt.label : opt,
                    value: typeof opt === 'object' ? opt[item.valueKey] || opt.value : opt
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 2
              }, 1032, ["remote", "remote-method", "onChange", "disabled", "style", "modelValue", "onUpdate:modelValue", "placeholder", "multiple", "collapse-tags", "clearable", "filterable"])) : item.type === 'cascader' ? (_openBlock(), _createBlock(_component_el_cascader, {
                key: 3,
                disabled: item.disabled,
                style: _normalizeStyle({
                  width: item.width || '100%'
                }),
                modelValue: _unref(formData)[item.prop],
                "onUpdate:modelValue": $event => _unref(formData)[item.prop] = $event,
                options: item.options,
                props: item.props,
                placeholder: item.placeholder || `请选择${item.label}`
              }, null, 8, ["disabled", "style", "modelValue", "onUpdate:modelValue", "options", "props", "placeholder"])) : item.type === 'date' ? (_openBlock(), _createBlock(_component_el_date_picker, {
                key: 4,
                "range-separator": "至",
                "start-placeholder": "开始日期",
                "end-placeholder": "结束日期",
                clearable: item.clearable,
                disabled: item.disabled,
                modelValue: _unref(formData)[item.prop],
                "onUpdate:modelValue": $event => _unref(formData)[item.prop] = $event,
                type: item.dateType || 'date',
                placeholder: item.placeholder || `选择日期`,
                "value-format": item.format || 'yyyy-MM-dd',
                style: {
                  "width": "100%"
                }
              }, null, 8, ["clearable", "disabled", "modelValue", "onUpdate:modelValue", "type", "placeholder", "value-format"])) : item.type === 'radio' ? (_openBlock(), _createBlock(_component_el_radio_group, {
                key: 5,
                onChange: $event => handleChange($event, item.prop),
                modelValue: _unref(formData)[item.prop],
                "onUpdate:modelValue": $event => _unref(formData)[item.prop] = $event
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, opt => {
                  return _openBlock(), _createBlock(_component_el_radio, {
                    key: opt.value,
                    label: opt.value
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(opt.label), 1)]),
                    _: 2
                  }, 1032, ["label"]);
                }), 128))]),
                _: 2
              }, 1032, ["onChange", "modelValue", "onUpdate:modelValue"])) : _createCommentVNode("", true), item.type === 'checkbox' ? (_openBlock(), _createBlock(_component_el_checkbox_group, {
                key: 6,
                modelValue: _unref(formData)[item.prop],
                "onUpdate:modelValue": $event => _unref(formData)[item.prop] = $event
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, opt => {
                  return _openBlock(), _createBlock(_component_el_checkbox, {
                    key: opt.value,
                    label: opt.label,
                    value: opt.value
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue"])) : item.type === 'switch' ? (_openBlock(), _createBlock(_component_el_switch, {
                key: 7,
                modelValue: _unref(formData)[item.prop],
                "onUpdate:modelValue": $event => _unref(formData)[item.prop] = $event,
                "active-text": item.activeText || '开',
                "inactive-text": item.inactiveText || '关',
                disabled: item.disabled
              }, null, 8, ["modelValue", "onUpdate:modelValue", "active-text", "inactive-text", "disabled"])) : item.type === 'slider' ? (_openBlock(), _createBlock(_component_el_slider, {
                key: 8,
                modelValue: _unref(formData)[item.prop],
                "onUpdate:modelValue": $event => _unref(formData)[item.prop] = $event,
                min: item.min,
                max: item.max,
                step: item.step || 1,
                disabled: item.disabled
              }, null, 8, ["modelValue", "onUpdate:modelValue", "min", "max", "step", "disabled"])) : item.type === 'color' ? (_openBlock(), _createBlock(_component_el_color_picker, {
                key: 9,
                modelValue: _unref(formData)[item.prop],
                "onUpdate:modelValue": $event => _unref(formData)[item.prop] = $event,
                disabled: item.disabled
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])) : item.type === 'upload' ? (_openBlock(), _createBlock(_component_el_upload, {
                key: 10,
                modelValue: _unref(formData)[item.prop],
                "onUpdate:modelValue": $event => _unref(formData)[item.prop] = $event,
                action: item.action,
                "list-type": item.listType || 'text',
                "show-file-list": item.showFileList || true,
                disabled: item.disabled
              }, {
                trigger: _withCtx(() => [_createVNode(_component_el_button, {
                  size: "small",
                  type: "primary"
                }, {
                  default: _withCtx(() => _cache[0] || (_cache[0] = [_createTextVNode("选择文件")])),
                  _: 1,
                  __: [0]
                })]),
                upload: _withCtx(() => [_createVNode(_component_el_button, {
                  size: "small",
                  type: "success",
                  loading: item.uploading,
                  disabled: item.disabled
                }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode(" 上传 ")])),
                  _: 2,
                  __: [1]
                }, 1032, ["loading", "disabled"])]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "action", "list-type", "show-file-list", "disabled"])) : item.type === 'slot' ? _renderSlot(_ctx.$slots, item.prop, {
                key: 11,
                data: _unref(formData)
              }) : _createCommentVNode("", true)]),
              _: 2
            }, 1032, ["label", "prop"]);
          }), 128)), __props.formConfig.hasAction ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              onClick: handleSubmit
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.submitText), 1)]),
              _: 1
            }), __props.hasRest ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              onClick: handleReset
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("重置")])),
              _: 1,
              __: [2]
            })) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "action")]),
            _: 3
          })) : _createCommentVNode("", true)]),
          _: 3
        }, 8, ["disabled", "model", "label-width", "rules", "inline", "label-position"])]),
        _: 3
      });
    };
  }
};